import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedNotificationService {
  // loaders
  private _isLoadingRowResults: boolean;
  private _onSupplierChange?: number;

  private onTabChange = new Subject<boolean>();
  private onSupplierChange = new Subject<number>();
  private isLoadingRowResults = new Subject<boolean>();

  public onTabChangeObservable = this.onTabChange.asObservable();
  public onSupplierChangeObservable = this.onSupplierChange.asObservable();
  public isLoadingRowResultsObservable = this.isLoadingRowResults.asObservable();

  constructor() {
    this._isLoadingRowResults = false;
    this._onSupplierChange = null;
  }

  // getters
  get getIsLoadingRowResults(): boolean { return this._isLoadingRowResults; }
  get getOnSupplierChange(): number { return this._onSupplierChange; }

  // setters
  public setIsLoadingRowResults(val: boolean) {
    this._isLoadingRowResults = val;
    this.isLoadingRowResults.next(val);
  }

  public setOnTabChange() {
    this.onTabChange.next(true);
  }

  public setOnSupplierChange(val: number) {
    this._onSupplierChange = val;
    this.onSupplierChange.next(val);
  }
}
